// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".events-heatmap__legend{padding-left:13px}.events-heatmap__legend>*{font-size:11px}.events-heatmap__legend__color{border-radius:2px;height:10px;margin:0 1.5px;width:10px}.heatmap-calendar__day rect{fill:#ebedf0}.heatmap-calendar__day--hovered rect{stroke:#5c6d97}.heatmap-calendar__day--selected rect{stroke:#17252d}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
